// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"bd669801","769":"ba2aaeab"}[chunkId] + ".chunk.css";
};